import { get, keys } from 'lodash';

import { Action } from '../../actions';
import {
    REMOVE_BANNER_VIDEO,
    UPDATE_BANNER_CPC_VIDEO_CREATIVE_ID,
    UPDATE_BANNER_VIDEO_CREATIVE_ID,
    UpdateBannerCpcVideoCreativeId,
    UpdateBannerVideoCreativeId
} from '../../actions/video';
import { EditBannersState, getEditedBannerWithVideo, MassActionId } from '../../typings/bannersEditState';
import { ValidationErrorsData } from '../../typings/common';
import { State } from '../../typings/state';

const updateBannerVideoCpcCreativeId = (
    state: EditBannersState,
    action: UpdateBannerCpcVideoCreativeId | UpdateBannerVideoCreativeId,
    fullState: State
): EditBannersState => {
    const banner = getEditedBannerWithVideo(fullState.editBanners.banners[action.id]);
    if (!banner) {
        return state;
    }

    const oldErrors = get(banner, 'errors', {});
    const newErrors = keys(oldErrors)
        .filter(key => key !== 'creativeId')
        .reduce(
            (acc: ValidationErrorsData, errorKey: string) => ({
                ...acc,
                [errorKey]: get(oldErrors, errorKey, [])
            }),
            {} as ValidationErrorsData
        );

    return {
        ...state,
        banners: {
            ...state.banners,
            [action.id]: {
                ...banner,
                creativeId: action.creativeId,
                errors: newErrors
            }
        }
    };
};

export function videoReducer(state: EditBannersState, action: Action, fullState: State): EditBannersState {
    switch (action.type) {
        case UPDATE_BANNER_VIDEO_CREATIVE_ID:
        case UPDATE_BANNER_CPC_VIDEO_CREATIVE_ID:
            return action.id === MassActionId.bannersEdit
                ? state
                : updateBannerVideoCpcCreativeId(state, action, fullState);

        case REMOVE_BANNER_VIDEO: {
            const banner = getEditedBannerWithVideo(fullState.editBanners.banners[action.id]);
            if (!banner || action.id === MassActionId.bannersEdit) {
                return state;
            }

            return {
                ...state,
                banners: {
                    ...state.banners,
                    [action.id]: {
                        ...banner,
                        creativeId: undefined
                    }
                }
            };
        }
        default:
            return state;
    }
}
